import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectsShort, getRealEstatesShort, getStatuses } from './api';

export const path = '/reports/delay-application';

const PageDelayApplicationReports: React.FC = (props) => {
  const DelayApplicationReports = Loadable.Map({
    loader: {
      page: () => import('./page'),
      realEstates: getRealEstatesShort,
      defects: getDefectsShort,
      statuses: getStatuses,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <DelayApplicationReports {...props} />;
};

export default PageDelayApplicationReports;
